// scrollingOpacity.js
var ScrollingOpacity = pc.createScript('ScrollingOpacity');

ScrollingOpacity.attributes.add('materialAsset', {
    type: 'asset'
});

ScrollingOpacity.attributes.add('speed', {
    type: 'vec2'
});

ScrollingOpacity.tmp = new pc.Vec2();

// initialize code called once per entity
ScrollingOpacity.prototype.initialize = function() {
    // get the material that we will animate
    if (this.materialAsset) {
        this.material = this.materialAsset.resource;
    } 
};

// update code called every frame
ScrollingOpacity.prototype.update = function(dt) {
    var tmp = ScrollingOpacity.tmp;
    
    // Calculate how much to offset the texture
    // Speed * dt
    tmp.set(this.speed.x, this.speed.y);
    tmp.scale(dt);


    // Update the diffuse and normal map offset values
    //this.material.glossMapOffset = this.material.diffuseMapOffset.add(tmp);
    this.material.opacityMapOffset.add(tmp);
    this.material.update();
};


